<template>
  <div class="home">

	  <el-carousel :interval="5000" arrow="always"  :height="imgHeight+'px'">
	     <el-carousel-item v-for="item in banner" :key="item">
			
	  <div class="h-banner">
	<div class="h-banner-t" v-if="item.show_button==1">
		<div class="ban-tit">
				 
		</div>
		<div class="ban-but">
				   <a :href="item.url">
				   立即顯示 >
					</a>
		</div>
	</div>
	<img class="npc" v-if='item.inventoryId==0' ref="image" :src="item.originalPic" />
	 <router-link v-else :to="'/product/details?id='+item.inventoryId">
		 <img class="npc" ref="image" :src="item.originalPic" />
		  </router-link>
	  </div>
	     </el-carousel-item>
	   </el-carousel>

   <div class="home-ct">
	   <div class="home-show">
	   	   <div class="tit">
	   		   <h4>產品展示會</h4>
			   <div> <router-link to="/product/list"><img src="../../assets/icon2.png" /></router-link></div>
			   
	   	   </div>
	
	   	   <div class="con">
	   		   <ul>
				   
				   <li v-for="item in hans"> 
				   <router-link  :to="'/product/list?id='+item.id">
					   <p>{{item.title}} <img src="../../assets/icon1.png"></p>
					   <p class="time">{{item.num}} 產品</p>
					   
					   </router-link>
				   </li>
			
				   <div class="clear"></div>
			   </ul>
	   	   </div>
	   </div>

	   <div class="home-arr" v-for="item in news" v-if="item.products.length>0">
		   
	   	   <div class="tit">
	   		   <h4>{{item.title}}</h4>
	   			  
	   	   </div>
	   	   <div class="con">
	   		   <ul>
				 
	   				   <li v-for="it in item.products">
						     <router-link :to="'/product/details?id='+it.inventoryId">
						  
						     <div class="skr">
							
								 
				  				 
								   <el-tooltip class="item" effect="dark" content="選擇選項" placement="left" popper-class="draw_share_atooltip">
								  <div> <img class="cart" @click.prevent="sandYart(it)" src="../../assets/cart.png" /></div>
								    </el-tooltip>
								 <el-tooltip class="item" effect="dark" content="快速查看" placement="left" popper-class="draw_share_atooltip">
								  <div> <img class="cart" @click.prevent="finding(it)" src="../../assets/find.png" /></div>
								  </el-tooltip>
								   <el-tooltip class="item" effect="dark" content="添加到心願單" placement="left" popper-class="draw_share_atooltip">
							  <div> 	<img class="cart" v-if="it.if_shoucang==0" @click.prevent="collect(it)" src="../../assets/like.png" /><img class="cart" v-else @click.prevent="collect(it)" src="../../assets/likes.png" /></div>
								  </el-tooltip>
							 </div>
						
					
						   
						   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
						   <div class="pic">
							   <img :src="it.img" />
						   </div>
						   <div class="txt">
							   <p>
{{it.title}}</p>
					
 <p class="time">
CN ¥ {{it.price_sale}} </p>
 
						   </div>
	   					 </router-link>		  
	   				   </li>
				
																	
	   				 
	   			   </ul>
				   <div class="all">
					     <router-link :to="'/product/list?id='+item.id">
					   <img src="../../assets/all.png" />
					   </router-link>
				   </div>
	   	   </div>
	   </div>
	   

   </div>
   <div class="banner2" :style="'background: url('+banner2+') center center'" > </div>
 
	<div v-if="cart">
			   <div class="brand" ></div>
	<div class="carts">
			<div class="cart-tit">
				<h4>購物車</h4>
				<div class="cr" @click="cart=false">CLOSE<img src="../../assets/arr.png"  /></div>
				
						</div>
						<div class="cart-con">
							<ul>
								<li v-for="item in roll">
									<div class="lt">
									<div class="pic">
										<img :src="item.image" />
									</div>
									<div class="txt">
										<p><b>{{item.title}}</b></p><p>{{item.num}}× <b>CN ¥ {{item.price_sale}}</b></p>
									</div>
									</div>
									<div class="clo" @click="bit(item)">
										<img src="../../assets/arr.png" />
									</div>
								</li>
							
						</ul>
						</div>
						
						<div class="cart-bot">
							<div class="l1">
								<h4>小計:</h4>
								<h4>CN ¥{{price}}</h4>
							</div>
							<div class="l2">
								<router-link to="/product/cart"><div class="h-button cart-but">查看購物車</div></router-link>
								<router-link to="/product/order"><div class="h-button cart-but">結帳</div></router-link>
							</div>
						</div>
			   
	</div></div>
 
 <el-dialog
:visible.sync="dialogVisible"
   width="1200px"
  :before-close="handleClose"
>
 <div class="product-st" >
 	 
 			   <div class="pic">
 				  <div class="l1">
 					
 					 <div class="block">
 						<img :src="proImg" />
 					   </div>
 				  </div>
 			
 			   </div>
 			    <div class="txt">
 					<h2>{{pro.title}}</h2>
 					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
 					<div class="l4">
 						CN ¥ {{pro.price_sale}}
 						<span></span>
 					</div>
 					<div class="l5">
 						 <el-input-number size="mini"  v-model="num"  :min="1" :max="pro.kucun" ></el-input-number>
 						 <div class="cart-but" @click="sandYart(pro)">添加到購物車</div>
 					</div>
 					<div class="wishlist">
 					
 						<div class="co2">
 						分享 ：
 													<a href="https://www.facebook.com/sharer.php?u=http://cn.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
 														
 													<a href="http://twitter.com/share?text=FuelMe&url=http://cn.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
 						<a href="http://service.weibo.com/share/share.php?url=http://cn.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
 						
 						</div>
 					
 					</div>
 				</div>
 </div>
 </el-dialog>

  </div>
</template>
<script>


export default {

  data() {
    return {
	
		
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		id:'',
		banner2:'',
		pro:'',
		proImg:'',
		cart:false,
		roll:'',
		hans:'',
		banner:'',
		imgHeight: ""
	
		
    
    };
  },  mounted() {
	  window.addEventListener("resize", () => {
	       this.imgHeight = this.$refs.image[0].height;
	     });

		this.sandMate();
		this.sandHans();
		this.sandAlt();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.img
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		imgLoad() {
		     this.$nextTick(function() {
		  
		       this.imgHeight = document.body.clientWidth*1/2.72
		     });
		   },
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						this.cart=true;
						this.sandCart()
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						this.price=this.price.toFixed(2)
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.sandMate()
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=index_channelPdts",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data;
						
						
					}
				 
				});
			
			},sandAlt(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=index_index",
				  data: {type:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.banner=data.data.banners;
						this.banner2=data.data.adverts[0].images[0].originalPic
						this.imgLoad();
						
					}
				 
				});
			
			},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channelData",
				  data: {type:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.hans=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss">

	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
.home{
	.home-ct{
		width: 1200px;
		margin: 0 auto;
	}
	.banner{
		width: 100%;
		height: 709px;
		background: url(../../assets/banner1.png);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		
	}
	.tit{
		display: flex;
		justify-content: space-between;
		align-items: center;
		h4{
			font-size: 24px;
			font-weight: normal;
		}
	
	}
	.all{
		text-align: center;
		margin: 30px;
	}
	.banner2{
		width: 100%;
		height: 444px;
	//	background: url(../../assets/banner2.gif) center center;
	
	}
	.h-banner{
		position: relative;
		.npc{
			width: 100%;
		}
		.h-banner-t{
			width: 100%;
			text-align: center;
			position: absolute;
			bottom: 20%;
			z-index: 999;
			.ban-tit{
				height: 221px;
			}
			.ban-but{
				font-size: 18px;
				width: 190px;
				height: 48px;
				background: url(../../assets/but.png);
				background-size: 100%;
				text-align: center;
				line-height: 48px;
				margin-top: 20px;
				margin: 50px auto;
				a{
					color: #000000;;
				}
				
			}
			
			.ban-but:hover{
				background: url(../../assets/but2.png);
				background-size: 100%;
				a{
					color: #FFFFFF
				}
			}
		}
	}
	.skr{
		display:none;
		flex-direction: column;
		position: absolute;
		top: 20px;
		right: 20px;
		color: #FFFFFF;
		z-index: 900;
		width: 61px;
		height: 145px;
		justify-content: space-evenly;
		align-content: center;
		text-align: center;
		background: url(../../assets/menu1.png);
			.cart{
				width: 20px;
				margin: 0 auto;
			}
		
		
	}
	.home-show{
		margin-top: 30px;
		.con{
			margin: 50px 0;
			ul{
			
				li{
					float: left;
					position: relative;
					width: 500px;
					p{
						color: #383838;
						font-size: 16px;
						
						img{
							margin-left:70px;
						}
					}
					.time{
						
						color: #999999;
						margin-top: 30px;
						font-size: 14px;
					}
					&:nth-child(3)  {
					  width: 200px;
					}
				}
				
			
				
			}
		
		}
		
	}

	.home-arr{
		.con{

			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				li{
					position: relative;
					width: 589px;
					height: 470px;
					border: 1px solid #EEEEEE;
					width: 49%;
					margin-top: 40px;
					
					.pic{
						width: 100%;
						height: 393px;
						overflow: hidden;
						img{
							width: 100%;
							height: 393px;
							transition: all 0.5s;
						}
						img:hover{
							 transform: scale(1.2);
						}
						
					
					}
					.txt{
						padding: 15px;
						line-height: 25px;
						font-size: 18px;
						p{
							height: 28px;
							overflow: hidden;
							color: #000000;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
						.time{
							color: #494949;
							font-size: 16px;
						}
					}
					.fit{
						position: absolute;
						top: -11px;
						left: 30px;
						z-index: 800;
					}
				}
				li:hover{
					.skr{
						display:flex;
					}
				}
			
			}
		}
	}

	.product-st{

		display: flex;
	
		.item-acticve{
			background: #333333;
		}
		.pic{
			width: 613px;
			.l1{
				img{
					width: 613px;
					height: 410px;
				}
				
			}
			
		}
		.txt{
			flex: 1;
			padding: 20px 40px;
			.l3{
				margin: 20px 0;
				img{
					width: 141px;
					height: 36px;
					
				}
			}
			.l4{
				color: #2D2A2A;
				font-size: 24px;
				span{
					color: #7C7C7C;
					font-size: 20px;
					margin-left:10px;
				
				}
			}
			.l5{
				display: flex;
				margin-top: 20px;
				.cart-but{
					font-size: 14px;
					width: 131px;
					height:38px;
					line-height: 38px;
					background-color: #FB2C00;
					color: #FFFFFF;
					text-align: center;
					margin-left: 20px;
				}
			}
			.wishlist{
				border-top: 1px solid #dedede;
				margin-top: 100px;
				padding-top: 30px;
				color: #2D2A2A;
				font-weight: bolder;
				img{
					height: 20px;
					margin-right: 10px;
				}
				.co1{
					display: flex;
					margin-bottom: 20px;
				}
				.co2{
					display: flex;
				}
				
			}
		}
	}
}
.el-tooltip__popper[x-placement^=left] .popper__arrow::after {
  
   border-left-color: #ffffff;
   
   
  }

.el-tooltip__popper[x-placement^=left] .popper__arrow{

 border-left-color: #ffffff;

}
.draw_share_atooltip{
   background: #ffffff !important;
   color: #000000 !important;
   border-radius: 0;
   
 }
.brand{
		  position:fixed;left:0px;top:0px;
		    background:rgba(0, 0, 0, 0.7);
		    width:100%; 
		    height:100%;
		    filter:alpha(opacity=70);  
		    opacity:0.7;  
		    z-Index:999;  
	}
	.carts{
		position: fixed;
		top: 0;
		right: 0;
		background: #FFFFFF;
		width: 354px;
		height: 100%;
		border: 1px solid #eeeeee;
		z-index: 1000;
		.cart-tit{
			font-size: 16px;
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			h4{
				font-size: 20px;
			}
			.cr{
				font-size: 14px;
			}
			img{
				width: 11px;
				height: 10px;
				margin-left: 20px;
			}
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-con{
			margin-bottom: 100px;
			li{
				padding: 20px;
				display: flex;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					font-size: 14px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
				
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
			position: absolute;
			width: 314px;
			bottom: 0;
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				justify-content: space-between;
				font-size: 20px;
				color: #2D2A2A;
			}
			.l2{
				font-size: 16px;
				.h-button{
					text-align: center;
					cursor: pointer;	
					padding: 0 50px;
					height: 50px;
					line-height: 50px;
					background: #000;
					color: #FFFFFF;
				}
			}
		}
	}
</style>